import { Description } from "@radix-ui/react-alert-dialog";

import { cn } from "@/lib/utils";

type AlertDescriptionProps = {
  children: React.ReactNode;
  className?: string;
};

const AlertDescription = ({ children, className }: AlertDescriptionProps) => (
  <Description className={cn("text-left", className)}>{children}</Description>
);

export { AlertDescription };
